import type { ValidationResult } from 'joi';
import { cloneDeep } from 'lodash';

import { EventType } from '../../../../../objects/org/event-type/event-type';
import { PossibleAdminRole } from '../../../../../objects/user/admin-roles/types';
import { PossibleRole } from '../../../../../objects/user/roles/types';
import { UserRequestName } from '../../../user-request-name';
import { UserRequest } from '../../generic/user-request/user-request';
import { UserRequestSchema } from '../../generic/user-request/user-request-schema';

import { UserRequestCreateOrgConstructor } from './user-request-create-org-constructor';
import { UserRequestCreateOrgSchema } from './user-request-create-org-schema';

export class UserRequestCreateOrg extends UserRequest {
  protected orgId!: string;

  protected displayName!: string;

  protected timezone!: string;

  protected e164Phones!: string[];

  protected eventTypes!: EventType[];

  constructor(parameters: UserRequestCreateOrgConstructor) {
    super({
      ...parameters,
      [UserRequestSchema.type]: UserRequestName.createOrg,
    });
  }

  /////////////////////////////////////////////////////////////////////////////
  // Deserialize
  /////////////////////////////////////////////////////////////////////////////

  protected static _deserialize(validationResult: ValidationResult): UserRequestCreateOrg {
    return new UserRequestCreateOrg(super._deserialize(validationResult));
  }

  /////////////////////////////////////////////////////////////////////////////
  // Schema
  /////////////////////////////////////////////////////////////////////////////

  public static getSchema(): UserRequestCreateOrgSchema {
    return new UserRequestCreateOrgSchema();
  }

  /////////////////////////////////////////////////////////////////////////////
  // Serialize
  /////////////////////////////////////////////////////////////////////////////

  public serialize() {
    return super.serialize(UserRequestCreateOrg.getSchema());
  }

  /////////////////////////////////////////////////////////////////////////////
  // Roles
  /////////////////////////////////////////////////////////////////////////////

  public getRequiredRoles(): PossibleRole[] {
    return ['orgAdmin'];
  }

  public getRequiredAdminRoles(): PossibleAdminRole[] | undefined {
    return ['pwpAdmin'];
  }

  /////////////////////////////////////////////////////////////////////////////
  // Getters
  /////////////////////////////////////////////////////////////////////////////

  public getOrgId(): string {
    return cloneDeep(this.orgId);
  }

  public getDisplayName(): string {
    return cloneDeep(this.displayName);
  }

  public getTimezone(): string {
    return cloneDeep(this.timezone);
  }

  public getE164Phones(): string[] {
    return cloneDeep(this.e164Phones);
  }

  public getEventTypes(): EventType[] {
    return cloneDeep(this.eventTypes);
  }
}
